import { Inject, Injectable } from '@angular/core';

import { NbaBaseResolversCollection } from '../nba-base-resolver-collection';

import { NbaParamResolver } from './nba-param-resolver.interface';
import { nbaParamResolverToken } from './nba-param-resolver.token';

@Injectable()
export class NbaParamResolversCollection extends NbaBaseResolversCollection<NbaParamResolver> {
  public constructor(@Inject(nbaParamResolverToken) resolvers: NbaParamResolver[]) {
    super(resolvers);
  }
}
